var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 64,
    height: 64,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.85745,111.95453c-1.06358,-1.03805 -2.68212,-1.25439 -3.9812,-0.53213c-9.92259,5.52248 -21.2027,8.44177 -32.62087,8.44177c-37.04752,0 -67.1875,-30.14031 -67.1875,-67.1875c0,-10.86724 2.65827,-21.66528 7.68726,-31.22673c0.6917,-1.3152 0.43705,-2.92904 -0.62619,-3.96742c-1.06291,-1.03838 -2.68246,-1.25473 -3.98086,-0.53213c-23.45012,13.05117 -38.01771,37.81077 -38.01771,64.61691c0,40.85134 33.06062,73.90625 73.90625,73.90625c27.53747,0 52.61487,-15.15515 65.44634,-39.5516c0.69237,-1.31587 0.43739,-2.92904 -0.62552,-3.96742zM90.03696,148.7548c-37.04752,0 -67.1875,-30.14031 -67.1875,-67.1875c0,-20.65848 9.51879,-39.9816 25.40662,-52.61587c-8.6598,25.62565 -3.01269,55.23182 17.73985,75.98503c21.29508,21.29541 51.78947,26.59281 77.64221,17.15834c-12.5822,16.66586 -32.28158,26.66 -53.60118,26.66z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.2d04c6193a000427763c9a48b2297129.svg";
export { ForwardRef as ReactComponent };